export default {
  "my": "My",
  "cv": "CV",
  "description": "I`m a hard-working <strong class='text-white'>software developer</strong> who looks forward to working with an open-minded team of individuals",
  "resume": "Resume",
  "name": "Dmytro BILOSTENKO",
  "achievement1": "I have confirmed CSS skills on LinkedIn",
  "achievement2": "Certification from Freecodecamp course on `Responsive Web Design` and `JavaScript Algorithms and Data Structures`, certification of completion of CyberBionic systematics school and IT Generation",
  "achievement3": "4 kyu Rank on CodeWars with total completed 600+ challenges in JavaScript",
  // titles
  "abo": "Abo",
  "utme": "ut me",
  "sta": "Sta",
  "ts": "ts",
  "сore": "Core",
  "tech": " tech stack & tools",
  "my": "My",
  "works": " works",
  "exp": "Exp",
  "erience": "erience",
  "ed": "Ed",
  "ucation": "ucation",
  "certificates" : "Certificates (point to the question mark)",
  "repos": "Repos on GitHub",
  "scores": "Score on Codewars",
  "ranks": "Rank: ",
  "new": "New",
  "old": "Old",
  "ukrainian": "Ukrainian",
  "english": "English",
  "details": "Details...",
  "linkToPage": "Link to Page",
  "linkToRepo": "Link to Repo",
  // PROJECT DESCRIPTIONS
  'calculatorDescription': 'Calculator written in Javascript',
  'marvelDescription': 'Find your marvel hero and check his biography.',
  'pizzaDescription': 'Just Javascript and nothing else =) Test functionality: add and remove pizza order, drag and drop, change the language, validation inputs in cart and etc.',
  'norrislDescription': 'Welcome to the Chuck Norris Joke Collection! Press the button and brace yourself for a laugh harder than Chuck`s roundhouse kick.',
  'shoppingDescription': 'Simple landing page build on React and GSAP animation library.',
  'karkikDescription': 'Simple landing page. Just JS and CSS.',
  'stateTaskDescription': 'Beginners projects for react state management',
  'courseDescription': 'Landing page with Bootstrap',
  'formsDescription': 'Learn how to use the forms',
  'cutspaceDescription': 'Simple landing page build on HTML, SCSS and JS',
  'bikcraftDescription': 'Simple landing page build on HTML, SCSS',
  'forms2Description': 'Simple landing page build on HTML, SCSS',
  'clubWebDescription': 'Simple landing page build on HTML, SCSS',
  'barberDescription': 'Simple landing page build on HTML, SCSS and JS with animation',
  'trevlandDescription': 'Simple landing page build on HTML and SCSS.',
  'kettlesDescription': 'Simple landing page build on HTML, SCSS and JS with animation',
  'accounterDescription': 'Simple landing page build on HTML, SCSS and JS',
  'taskManagerDescription': 'Task Manager built on React and useReducer hooks.',
  'reactFormDescription': 'Simple form built on React.',
  'keyCodeDescription': 'Press the keypad button and you will see its code.',
  'pizzaDescription': 'Pizza constructor with drug & drop.',
  'japanDescription': 'Landing page about Japan.',
  // PROJECT NAMES
  'calculatorName': 'Calculator',
  'marvelName': 'Marvel Characters',
  'pizzaName': 'Pizza Website',
  'chukNorrisName': 'Chuk Norris Joke Collection',
  'shoppingName': 'Shopping lannding page',
  'karkikName': 'Karkik landing page',
  'reactStateName': 'React state task',
  'courseName': 'Course adversting landing page',
  'formsName': 'Work with inputs, radio btns, checkboxes and etс.',
  'cutspaceName': 'Cutspace landing page.',
  'bikcraftName': 'Bikсraft landing page.',
  'forms2Name': 'Work with inputs, radio btns, checkboxes and etс. Vol.2',
  'clubWebName': 'ClubWeb landing page.',
  'barberName': 'Barber landing page.',
  'trevlandName': 'Trevland landing page.',
  'kettleName': 'Kettles landing page.',
  'accounterName': 'Accounter landing page.',
  'reactFormName': 'React forms.',
  'keyCodeName': 'JavaScript keyCode.',
  'pizzaName': 'Pizza constructor',
  'japanName': 'Japan landing page',
  // EDUCATION
  'university': 'National University of Internal Affairs',
  'degree': 'Bachelor`s degree in law',
  'itGeneration': 'IT Generation:',
  'development': 'Front-End development',
  'freeCodeCamp': 'FreeCodecamp:',
  'responsiveWebDesign': 'Responsive Web Design (certificate may be provided upon request)',
  'algorithms': 'JavaScript Algorithms and Data Structures',
  'prometheus': 'Web UI development basics 2020',
  'udemy': 'Udemy',
  'git': 'Git: Complete course for beginners and more (certificate may be provided upon request)',
  'jsCourse': 'The Complete JavaScript course + React Course',
  'basicCSS&HTML': 'Basic CSS and HTML',
  'cyberBionic': 'CyberBionic systematics:',
  'starterJS': 'course "JavaScript starter" (certificate may be provided upon request)',
  'essentialJS': 'course "JavaScript essential" (certificate may be provided upon request)',
  'npu': 'National Police of Ukraine',
  'senior': 'Senior inspector in special assigment of the International Police Cooperation Department (Interpol)',
};
